import { render, staticRenderFns } from "./minting-details.vue?vue&type=template&id=c8ccdf5c&scoped=true&"
var script = {}
import style0 from "./minting-details.vue?vue&type=style&index=0&id=c8ccdf5c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8ccdf5c",
  null
  
)

export default component.exports